import React, { useState } from "react";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { selectCars } from "../features/car/carSlice";
import { useSelector } from "react-redux";

function Header() {
  const [burgerStatus, setBurgerStatus] = useState(false);
  // const [isMousedOver, setIsMouseOver] = useState(false);
  const cars = useSelector(selectCars);
  console.log(cars);

  // const customStyle = {
  //   backgroundColor: "black",
  // };

  const overlayBurgerNav = document.querySelector(
    ".nav-list .overlayBurgerNav"
  );
  const nav_list = document.querySelectorAll(".nav-list li");
  console.log("nav_list", nav_list);
  console.log("overlayBurgerNav", overlayBurgerNav);

  nav_list.forEach((list) => {
    list.addEventListener("mouseover", () => {
      const position = list.getBoundingClientRect();
      overlayBurgerNav.classList.add("activeLi");
      overlayBurgerNav.style.left = "30px";
      overlayBurgerNav.style.top = position.top + "px";
      overlayBurgerNav.style.height = position.height + "px";
      overlayBurgerNav.style.width = position.width + "px";
    });
    list.addEventListener("mouseout", () => {
      overlayBurgerNav.classList.remove("activeLi");
    });
  });

  // function handleMouseOver() {
  //   setIsMouseOver(true);
  // }

  // function handleMouseOut() {
  //   setIsMouseOver(false);
  // }

  return (
    <Container>
      <a href="/">Nguyen Dinh Nam</a>
      <Menu>
        {cars &&
          cars.map((car, index) => (
            <a key={index} href="/">
              {car}
            </a>
          ))}
      </Menu>
      <RightMenu>
        <a href="https://namnguyenshop.herokuapp.com/">Shop</a>
        <CustomMenu onClick={() => setBurgerStatus(true)}>Menu</CustomMenu>
      </RightMenu>
      <BurgerNav
        show={burgerStatus}
        // style={isMousedOver ? customStyle : null}
        // onMouseOver={handleMouseOver}
        // onMouseOut={handleMouseOut}
        className="nav-list"
      >
        <CloseWrapper>
          <CustomClose onClick={() => setBurgerStatus(false)} />
        </CloseWrapper>
        <div class="overlayBurgerNav"></div>
        {cars &&
          cars.map((car, index) => (
            <li>
              <a key={index} href="/">
                {car}
              </a>
            </li>
          ))}

        <li>
          <a href="/">Automation System Integrator</a>
        </li>
        <li>
          <a href="/">Robots Developer</a>
        </li>
        <li>
          <a href="/">Warehouse Management System</a>
        </li>
        <li>
          <a href="/">Internet Of Things</a>
        </li>
        <li>
          <a href="/">Full-Stack Developer</a>
        </li>
        <li>
          <a href="/">Mobile Developer</a>
        </li>
        <li>
          <a href="/">Artificial Intelligence</a>
        </li>
        <li>
          <a href="/">Machine Learning</a>
        </li>
        <li>
          <a href="/">Data Science</a>
        </li>
        <li>
          <a href="https://namnguyenshop.herokuapp.com/">Nam Nguyen Shop</a>
        </li>
        <li>
          <a href="https://math-garden-ai.netlify.app/">
            AI Game - Math Garden
          </a>
        </li>
        <li>
          <a href="https://namnguyenlearnit.netlify.app/">Learn Tracking</a>
        </li>
        <li>
          <a href="https://3d-shoe-color-picker.netlify.app/">
            3D Web App - Advanced Tech
          </a>
        </li>
        <li>
          <a href="/contact">Contact Me</a>
        </li>
      </BurgerNav>
    </Container>
  );
}

export default Header;

const Container = styled.div`
  min-height: 50px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;

  a:hover {
    text-decoration: none;
    transition-delay: 0.5s;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
    flex-wrap: nowrap;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 5px 15px;

    :hover {
      background-color: #f2f2f2;
      border-radius: 15px;
      transition-delay: 0.5s;
    }
  }
`;

const CustomMenu = styled.div`
  cursor: pointer;
  font-weight: 600;
  text-transform: uppercase;
  padding: 5px 15px;

  :hover {
    color: red;
    background-color: #f2f2f2;
    border-radius: 15px;
    transition-delay: 0.5s;
  }

  @media (max-width: 768px) {
    background-color: #f2f2f2;
    border-radius: 15px;
  }
`;

const BurgerNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #fcfcfc;
  opacity: 0.99;
  z-index: 16;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.2s ease-in;

  li {
    margin: 6px 10px;
    padding: 6px 5px;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    // :hover {
    //   background-color: #f2f2f2;
    //   border-radius: 15px;
    //   transition-timing-function: ease-in-out;
    //   transition-delay: 0.2s;
    //   transition-duration: 0.3s;
    // }

    // :hover a {
    //   transition-delay: 0.5s;
    // }

    a {
      font-weight: 600;
      font-size: 0.95rem;
      text-transform: capitalize;
    }
  }
`;

const CustomClose = styled(CloseIcon)`
  cursor: pointer;
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
